import React from "react";
import Popup from "../../../../Helpers/Popup/Popup";
import { Modal } from "react-bootstrap";
import PopupTitle from "../../../../Helpers/Popup/PopupParts/PopupTitle";
import Close from "../../../../Helpers/CloseBtn/Close";
import RequestPopupBody from "../../../RegularMaintenance/PopupBody/RegularPopupBody";
import Button from "../../../../Helpers/Button/Button";
import MaintenanceList from "./MaintenanceList";

const ViewMore = ({ events, onClose, date }) => {
  console.log(events);
  return (
    <Popup size={"lg"} show={true}>
      <Modal.Header className="modal-header flex-between">
        <Modal.Title id="contained-modal-title-vcenter">
          <PopupTitle
            headtitle={`Available Maintenance Schedules ${events.length}`}
            subtitle={date}
          />
        </Modal.Title>
        <div className="flex-row gap-16">
          <Close style="close-32 close" close={() => onClose()} img="Close" />
        </div>
      </Modal.Header>
      <Modal.Body className="modal-body-scrollable">
        <MaintenanceList events={events} />
      </Modal.Body>
      {/* <Modal.Footer>
        <Button
          style="button fs-14 p-6-12 btn-default"
          type="button"
          text="Reject"
          onClick={() => onClose()}
        />
        <Button
          text="Approve"
          type="submit"
          style="button fs-14 p-6-12 btn-success"
        />
      </Modal.Footer> */}
    </Popup>
  );
};

export default ViewMore;
